var render = function render(_c, _vm) {
  return _c("div", { class: _vm.$style.margin }, [
    _c("table", { staticClass: "final-agreement" }, [
      _c("thead", [
        _c("tr", { staticClass: "heading" }, [
          _c("th", { staticClass: "rate", class: _vm.$style.headingCell }, [
            _vm._v(" Dynamic Rate: "),
          ]),
          _c(
            "th",
            { staticClass: "rate", class: _vm.$style.rateCell },
            [_vm._t("default")],
            2
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }